import { gql } from '@apollo/client';

export const UPSERT_USER_TO_ACCESS_GROUP = gql`
  mutation UpsertUserv2($upsertUserv2Input2: UpsertUserAccessGroupInput!) {
    upsertUserv2(input: $upsertUserv2Input2) {
      ... on AccessGroupv2 {
        id
        parentId
        name
        description
        members {
          user {
            id
            firstName
            lastName
          }
        }
      }
      ... on AccessGroupv2InfoResult {
        message
        item
        isSuccess
      }
    }
  }
`;
